export const enum MyPurchasesGenericEvents {
	MY_PURCHASES = 'my_purchases',
	GO_SHOPPING = 'go_shopping',
	LOADING_ERROR = 'loading_error',
	DOWNLOAD_RETURN_LABEL = 'download_return_label',
	DOWNLOAD_RETURN_FORM = 'download_return_form',
	RETURNS_CLICK = 'returns_click',
	FIND_STORE = 'find_store',
	PURCHASE_DETAIL = 'purchase_detail',
	SEARCH_ORDER = 'track_online_order',
	CREATE_ACCOUNT = 'mypurchases_signup',
	CANCEL_ORDER = 'cancel_order',
	SIMPLE_ORDER = 'unique',
	MULTI_ORDER = 'multi_order',
}
